import { useContext } from "react"
import { Routes, Route, Navigate } from "react-router-dom"

import Login from "@pages/Login"

import mobileRoutes from "./routes/mobileRoutes"
import { AuthContext } from "./App"

function MobileContent() {
  const tokenIsValid = useContext(AuthContext)
  return (
    <Routes>
      <Route
        path={"/login"}
        element={tokenIsValid ? <Navigate to="/" /> : <Login />}
      />
      {mobileRoutes.map((route, idx) => {
        return (
          route.element && (
            <Route
              key={idx}
              path={route.path}
              element={
                tokenIsValid ? <route.element /> : <Navigate to="/login" />
              }
            />
          )
        )
      })}
    </Routes>
  )
}

export default MobileContent
